var _g, _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 29,
    viewBox: "0 0 27 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4715_6300)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.82031 0.472961C2.26803 0.472961 1.82031 0.920676 1.82031 1.47296V27.473C1.82031 28.0252 2.26803 28.473 2.82031 28.473H24.1536C24.7059 28.473 25.1536 28.0252 25.1536 27.473V5.13963L20.487 0.472961H2.82031Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4863 0.472961V5.13963H25.153L20.4863 0.472961Z",
    fill: "#C2CDDE"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.654297,
    y: 12.1396,
    width: 25.6667,
    height: 11.6667,
    rx: 1,
    fill: "#F14848"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.24574 20.973V15.1548H8.42756C8.87453 15.1548 9.24953 15.2381 9.55256 15.4048C9.85748 15.5714 10.0876 15.8006 10.2429 16.0923C10.4001 16.3821 10.4787 16.7116 10.4787 17.0809C10.4787 17.454 10.4001 17.7855 10.2429 18.0752C10.0857 18.365 9.85369 18.5932 9.54688 18.7599C9.24006 18.9247 8.86222 19.0071 8.41335 19.0071H6.96733V18.1406H8.27131C8.53267 18.1406 8.74669 18.0951 8.91335 18.0042C9.08002 17.9133 9.20313 17.7883 9.28267 17.6292C9.36411 17.4701 9.40483 17.2874 9.40483 17.0809C9.40483 16.8745 9.36411 16.6927 9.28267 16.5355C9.20313 16.3783 9.07907 16.2561 8.91051 16.169C8.74384 16.08 8.52888 16.0355 8.26562 16.0355H7.29972V20.973H6.24574ZM13.3658 20.973H11.3942V15.1548H13.4055C13.9832 15.1548 14.4794 15.2713 14.8942 15.5042C15.3108 15.7353 15.6309 16.0677 15.8544 16.5014C16.0779 16.9351 16.1896 17.454 16.1896 18.0582C16.1896 18.6642 16.0769 19.1851 15.8516 19.6207C15.6281 20.0563 15.3052 20.3906 14.8828 20.6235C14.4624 20.8565 13.9567 20.973 13.3658 20.973ZM12.4482 20.061H13.3146C13.7199 20.061 14.058 19.9872 14.3288 19.8394C14.5997 19.6898 14.8033 19.4673 14.9396 19.1718C15.076 18.8745 15.1442 18.5033 15.1442 18.0582C15.1442 17.6131 15.076 17.2438 14.9396 16.9502C14.8033 16.6548 14.6016 16.4341 14.3345 16.2883C14.0694 16.1406 13.7398 16.0667 13.3459 16.0667H12.4482V20.061ZM17.1911 20.973V15.1548H20.9183V16.0383H18.245V17.6178H20.6626V18.5014H18.245V20.973H17.1911Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4715_6300"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.3333,
    height: 28,
    fill: "white",
    transform: "translate(1.82031 0.472961)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.a6ec31d782cceafc341ef40d1172a735.svg";
export { ForwardRef as ReactComponent };